<template>
  <div id="content" class="business_challenge_space">

    <div class="container ">


    <div class=" business_challenge_space_1 " >
      <div class="row space_title_zone">
        <div class="col-12 col-lg-6 col-xl-9">
          <span class="space_title">START A NEW PROJECT</span>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-6 mt20">
          <div class="zone_input">
            <div class="zone_input_header">
              <img :src="require('@/assets/start_a_new_project_project_name.svg')" class="zone_input_icon" alt="">
              <span class="zone_input_name">Project name</span>
            </div>
            <input type="text" class="innopearl_input tupper" v-model="project.name" :disabled="!canAddSF">
          </div>
        </div>
        <div class="col-12 col-lg-6 mt20">
          <div class="zone_input">
            <div class="zone_input_header">
              <img :src="require('@/assets/start_a_new_project_business_opportunity.svg')" class="zone_input_icon" alt="">
              <span class="zone_input_name">Business opportunity</span>
            </div>
            <textarea  v-model="project.business_challenge.business_opportunity" placeholder="What is your business challenge or key question you want to answer?" cols="20" rows='5' :disabled="!canAddSF"></textarea>
          </div>
        </div>
      </div>
      <div class="row ">
        <div class="col-12 col-xl-6">
            <div class="zone_input">
              <div class="zone_input_header">
                <img :src="require('@/assets/complete_the_following_sections2_search_fields.svg')" class="zone_input_icon" alt="">
                <span class="zone_input_name">SEARCH FIELDS</span>
              </div>
              <div class="zone_input_subheader">
                <span class="zone_input_subname">Specific areas of interest</span>
              </div>
              <div class="">
                <div class="search_field_input" v-for="(sf,i) in project.search_field" :key="i">
                  <input type="text" class="innopearl_input" v-model="project.search_field[i].name" :disabled="!sf.isNew"/>
                </div>
                <!-- <div class="add_custom_key_factor_without_text" v-if="canAddSF">
                  <button type="button" name="button" @click='addMoreSearchField()'>+ ADD</button>
                </div> -->
              </div>





            </div>
        </div>
      </div>


      <!-- <div class="step_footer">
        <span class="notice">The data you provide is solely for your own records and for Innopearl experts to help you define the challenge.</span>
        <button type="button" name="button" class="next_step_btn" @click='next_step()'>
          Next step
          <img :src="require('@/assets/next.svg')" alt="">
        </button>
      </div> -->

      <div class="step_footer">
        <div class="row row_center">
          <div class="col-12 col-xl-8">
            <span class="notice">The data you provide is solely for your own records and for Innopearl experts to help you define the challenge.</span>
          </div>
          <div class="col-12 col-xl-4 text-right">
            <button type="button" name="button" class="next_step_btn" @click='validateChallenge()'>
              Next step
              <img :src="require('@/assets/next.svg')" alt="">
            </button>
          </div>
        </div>

      </div>
    </div>


  </div>
</div>
</template>
<script>
import { toast } from 'vue-sonner'
import api from '../tools/api';
import _ from 'lodash';
import { toRaw } from 'vue';

// import Treeselect from 'vue3-treeselect'
// // import the styles
// import 'vue3-treeselect/dist/vue3-treeselect.css'

export default {
  components: {
  },
  data() {
    return {
      add_other_objectif: "",
      dialog : false,

      step: 1,
      pageInfo: {
        mainTitle : "Create a project",
        subTitle : "Basic Customer information",
      },
      project: {
        business_challenge: {
          isSubmit : false,
          business_opportunity: ""
        },
        search_field: [{name:"",isNew :true}],
      },
    }
  },
  computed:{
    canAddSF : function(){
      if(this.project.business_challenge.isSubmit){
        if(this.project.scouting_challenge){
          if(this.project.scouting_challenge.isSubmit == true) return false;

        }
        if(this.project.assessment_challenge){
          if(this.project.assessment_challenge.isSubmit == true)return false;
        }
      }
      if(this.project.scouting_challenge){
        if(this.project.scouting_challenge.isSubmit == true)return false;
      }
      if(this.project.assessment_challenge){
        if(this.project.assessment_challenge.isSubmit == true)return false;
      }
      return true;
    }
  },
  methods:{
    gobackrouter : function(){
      this.$router.go(-1);
    },
    addMoreSearchField(){
      this.project.search_field.push({name:"",isNew : true});
    },
    isBusinessChallengeValid() {
      let rawProject = toRaw(this.project)
      if(!rawProject.name)return false;
      if(rawProject.search_field[0].name == "")return false;
      if(!rawProject.business_challenge.business_opportunity)return false;
      return true;
    },
    validateChallenge(){
      if(this.isBusinessChallengeValid()){
        toast.promise(() => new Promise((resolve,reject) => {
          this.project.name = this.project.name.toUpperCase()
          api.post(process.env.VUE_APP_API_URL+"/restrict/init_project_no_business_challenge",this.project,{
              headers: {
                  'Content-Type': 'application/json',
              }
          }).then( (r) => {
            console.log(r);
            resolve(r.data);

          }).catch( () => {
             reject(new Error("Error!"));
          });
        }), {
        loading: 'Project creation in progress. Please wait a moment ... ',
        success: (data) => {
          //this.$store.commit('UPDATE_NOTIFICATION',1);
          if(this.project.challenges.business_challenge == true){
            //go to scouting directly
            this.$router.push('/business_challenge_space/'+this.project._id.$oid);
          }
          else if(data.search_fields.length == 1){

            if(this.project.challenges.scouting_challenge == true){
              //go to scouting directly
              this.$router.push('/scouting_space/'+data.search_fields[0]._id.$oid+"/"+this.project._id.$oid);
            }
            else if(this.project.challenges.assessment_challenge == true){
              //go to assessment directly

              console.log(data.search_fields[0]._id);
              this.$router.push('/startups_ecosystem/');
            }
          }
          else{
            this.$router.push('/projet/'+this.project._id.$oid);
          }
          // this.$router.push('/projet/'+this.project._id.$oid);
          this.$store.commit('UPDATE_PROJECTS',this.project)
          return 'Your project has been initiated.'
        },
        error: () => 'Error during project submission. Please try again.'
      });
      }
      else{
        toast.error("Oops! All fields are required. Please check your inputs and resubmit.")
      }


    },



  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

   api.get(process.env.VUE_APP_API_URL+"/restrict/project/"+this.$route.params.projectid).then( (r) => {
     // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
     // console.log();
     console.log(r.data);
     var d = JSON.parse(r.data);
     d.search_field.forEach((item) => {
       item.isNew = false;
     });

     var temp = _.merge(this.project, d);
     this.project = temp;
     console.log(this.project);
   }).catch( (e) => {
   if(e.response.status == 403)toast.error("To request access to this resource, please contact us");
   else toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
 });

  }
}
</script>
<style scoped>

.business_challenge_space{
  padding-top:50px;
}

.business_challenge_space_1,
.business_challenge_space_2,
.business_challenge_space_3{
  padding: 50px;
  background: #FFF;
}
.space_title_zone{
  margin-bottom: 50px;
}
.space_title{
  text-align: left;
  font-size: 21px;
  line-height: 25px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
opacity: 1;
display: block;
}
.zone_input{
}
.zone_input_icon{
  width: 55px;
}
.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: #3783C5;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  align-items: center;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: calc(100% - 65px);
box-sizing: border-box;
margin-top:20px;
margin-bottom: 20px;
height: 40px;
padding: 5px;
margin-left: 65px;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}
textarea{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: calc(100% - 65px);
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 margin-left: 65px;
}


.step_footer{
  /* display:flex;
  margin-top: 50px;
  align-items: center; */
  margin-top: 50px;
}
.step_footer .notice{
  flex: 1;
  font-size:14px;
  line-height: 22px;
  font-weight: 300;
}
.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img{
  margin-left:10px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}

.business_challenge_space_2 .row{
  margin-top:25px;
  margin-bottom: 25px;
}

.zone_input_subname{
  text-align: left;
  font-size:16px;
  line-height: 22px;
letter-spacing: 0px;
color: #3783C5;
margin-left: 65px;
-webkit-box-decoration-break: clone;
box-decoration-break: clone;
}
.zone_input_checkboxes{
  margin-left: 65px;
  width: calc(100% - 65px);
  display: flex;
  margin-top:20px;
  gap: 20px;
  flex-wrap: wrap;
}

.partnership_objectives_label{
  padding:12px 30px;
  background: #EFEFEF 0% 0% no-repeat padding-box;
border-radius: 3px;
min-width: calc(20% - 20px);
max-width: calc(20% - 20px);
flex-basis: 0;
flex: 1;
display:flex;
flex-direction: column;
gap: 10px;
border: 1px solid #EFEFEF;
}

@media screen and (max-width: 990px){
  .partnership_objectives_label{
    min-width: calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
}

@media screen and (max-width: 690px){
  .partnership_objectives_label{
    min-width: calc(100% - 20px);
    max-width: calc(100% - 20px);
  }
}
input[type='checkbox']{
  width: 24px;
height: 24px;
margin-top:auto;
}
.checkbox_container{
  width:100%;
  display:block;
  text-align: right;
  align-self: end;
margin-top: auto;
}
.partnership_objectives_label.add_other_objectif{
background:#FFF;
}
.add_other_objectif input{
  border:1px solid #EFEFEF;
  padding: 5px;
}
.checkbox_container button{
  font-size: 18px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
}
.ligne_form{
  margin-top: 50px;
}

.vselect_container{
  margin-top: 20px;
}
.vselect_container .v-field{
  background: #FFF !important;
  border: 1px solid #CCC;
}
.vselect_container .v-field__field,
.vselect_container .v-field__append-inner{
    background: #FFF !important;
}
.v-field--variant-filled .v-field__overlay {
  opacity: 0 !important;
}
.vselect_container .v-field__append-inner i {
  color: #3783C5;
}
.add_custom_key_factor{
  display: flex;
  justify-content: center;
}
.add_custom_key_factor_without_text{
  display: flex;
  justify-content: flex-end;
}
.add_custom_key_factor span{
  font-size: 16px;
  line-height: 22px;
  font-weight: 300;
  flex-grow: 1;
}
.add_custom_key_factor button,
.add_custom_key_factor_without_text button{
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: #3783C5;
text-transform: uppercase;
}
.ligne_inner_form{
  margin-top:40px;
}
.inputs_container{
  margin-left: 65px;
}
.vselect_container,
.ligne_inner_form .vselect_container{
  margin-left:65px;
}
.v-autocomplete .v-field .v-field__input{
  padding: 7px;
min-height: 40px;

}
.search_field_input input{
  margin-top: 10px;
  margin-bottom: 10px;
}

.row_center{
  align-items: center;
}

.flex-column-align-input-bottom{
  display:flex;
  flex-direction: column;
}
.flex-column-align-input-bottom .zone_input_subname{
  margin-bottom: 10px;
}
.flex-column-align-input-bottom > .vselect_container,
.flex-column-align-input-bottom >  .vue-treeselect__control{
  margin-top: auto;
}

@media screen and (max-width:690px){
  textarea{
   margin-left: 0;
   width: 100%
  }
  .zone_input_subname{
    margin-left:0;
    margin-top: 10px;
  }
  .zone_input_checkboxes{
    margin-left: 0 !important;
    width:100%;
  }
  .vselect_container{
    margin-left: 0 !important;
  }
  .inputs_container{
    margin-left: 0 !important;
  }
  .business_challenge_space_1,
  .business_challenge_space_2,
  .business_challenge_space_3{
    padding-left:10px;
    padding-right:10px;
  }
}

</style>
<style media="screen">
.vue-treeselect__control{
  background: #CCC;
  height: 60px;
}

.vue-treeselect__multi-value-item{
  align-items: center;
cursor: default;
display: inline-flex;
font-weight: 400;
max-width: 100%;
min-width: 0;
overflow: hidden;
position: relative;
text-decoration: none;
white-space: nowrap;
vertical-align: middle;
border-color: rgba(var(--v-border-color), var(--v-border-opacity));
border-style: solid;
border-width: 0;
border-radius: 9999px;
font-size: 0.75rem;
padding: 4px 10px;
height: calc(var(--v-chip-height) + 0px);
color: #000;
}
.vue-treeselect__icon ,
.vue-treeselect__icon:hover {
  cursor: pointer;
flex: 0 1 auto;
font-size: 18px;
max-height: 18px;
max-width: 18px;
-webkit-user-select: none;
-moz-user-select: none;
user-select: none;
color: #FFF !important;
background: #000;
border-radius: 60%;
padding: 5px;
margin-inline-start: 5px;
-webkit-margin-end: -5px;
margin-inline-end: -5px;
}
.vue-treeselect__x-container{
  display:none;
}
.vue-treeselect__control-arrow-container{
  display: flex;
}
.mt20{
  margin-top:20px;
}
.briefUploader{
  cursor:pointer;
}
.briefUploader input[type="file"]{
  display:none;
}
.table_brief_doc{
  margin-top:20px;
}
.table_brief_doc thead td{
  background: #EEE;
  padding-top:10px;
  padding-bottom:10px;
}
.table_brief_doc tbody{
  border:1px solid #EEE;
}
.table_brief_doc a{
  color: inherit;
}
.table_brief_doc svg{
  color: #3783C5
}
.tupper{
  text-transform: uppercase;
}
</style>
